import { FC, useContext } from 'react';

import MenuIcon from '@material-ui/icons/Menu';
// import { ReactComponent as Logo } from 'src/assets/svg/logo.svg';
import UserMenu from 'src/routes/Private/Layout/TopNavigation/UserMenu';
import PrivateContext from 'src/routes/Private/PrivateContext';

import { AppBar, Toolbar, MenuButton, Title } from './styles';

const TopNavigation: FC = () => {
  const { sideMenuIsOpen, openSideMenu } = useContext(PrivateContext);

  return (
    <AppBar position="absolute" isOpen={sideMenuIsOpen}>
      <Toolbar>
        <MenuButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={openSideMenu}
          isOpen={sideMenuIsOpen}
        >
          <MenuIcon />
        </MenuButton>

        <Title variant="h6" color="inherit" noWrap>
          Seja bem-vindo(a)
        </Title>

        <UserMenu />
      </Toolbar>
    </AppBar>
  );
};

export default TopNavigation;
